"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ANONYMOUS_USER_SETTINGS = exports.ANONYMOUS_USER_ID = exports.DEFAULT_LOCALE = void 0;
exports.DEFAULT_LOCALE = "en-US";
exports.ANONYMOUS_USER_ID = "Anonymous";
exports.ANONYMOUS_USER_SETTINGS = {
    locale: exports.DEFAULT_LOCALE,
    userId: exports.ANONYMOUS_USER_ID,
    separators: {
        thousand: ",",
        decimal: ".",
    },
};
//# sourceMappingURL=constants.js.map